'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustNumberWithUnit = exports.unitedDimensionToUnitlessPixelValue = exports.remOrEmToPxValue = exports.mulitplyUnitlessNumbersToDistance = exports.unitlessNumberToDistance = exports.ratioToPercentString = exports.percentageStringToRatio = exports.pxValueToPxString = exports.pxValueToRemOrEmString = exports.pxValueToRemOrEmValue = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _units = require('../const/units');

var _formatting = require('./formatting');

var _numbers = require('./numbers');

var _parse = require('./parse');

var _predicate = require('./predicate');

var PX = _units.LENGTH_UNITS.PX,
    REM = _units.LENGTH_UNITS.REM,
    EM = _units.LENGTH_UNITS.EM;
var pxValueToRemOrEmValue = exports.pxValueToRemOrEmValue = function pxValueToRemOrEmValue(value, baseFontSize) {
  return (0, _ramda.divide)(value, baseFontSize);
};

var pxValueToRemOrEmString = exports.pxValueToRemOrEmString = function pxValueToRemOrEmString(unit, baseFontSize, value) {
  return (0, _formatting.joinWithNoSpace)([(0, _ramda.flip)(pxValueToRemOrEmValue)(baseFontSize)(value), unit]);
};

var pxValueToPxString = exports.pxValueToPxString = function pxValueToPxString(value) {
  return (0, _formatting.joinWithNoSpace)([value, PX]);
};

var percentageStringToRatio = exports.percentageStringToRatio = (0, _ramda.compose)((0, _numbers.divideBy)(100), _parse.numericPartOfUnitedNumberString);

var ratioToPercentString = exports.ratioToPercentString = (0, _ramda.compose)((0, _ramdaAdjunct.concatRight)(_units.PERCENT_UNIT), String, (0, _ramda.multiply)(100));

var unitlessNumberToDistance = exports.unitlessNumberToDistance = function unitlessNumberToDistance(unit, baseFontSize) {
  return function (value) {
    return (0, _ramda.cond)([[(0, _ramda.equals)(PX), function () {
      return pxValueToPxString(value);
    }], [(0, _ramda.equals)(REM), function () {
      return pxValueToRemOrEmString(REM, baseFontSize, value);
    }], [(0, _ramda.equals)(EM), function () {
      return pxValueToRemOrEmString(EM, baseFontSize, value);
    }]])(unit);
  };
};

var mulitplyUnitlessNumbersToDistance = exports.mulitplyUnitlessNumbersToDistance = function mulitplyUnitlessNumbersToDistance(factor, unit, baseFontSize) {
  return (0, _ramda.pipe)(_parse.numericPartOfUnitedNumberString, (0, _ramda.multiply)(factor), unitlessNumberToDistance(unit, baseFontSize));
};

var remOrEmToPxValue = exports.remOrEmToPxValue = function remOrEmToPxValue(value, baseFontSize) {
  return (0, _ramda.multiply)(value, baseFontSize);
};

var unitedDimensionToUnitlessPixelValue = exports.unitedDimensionToUnitlessPixelValue = function unitedDimensionToUnitlessPixelValue(value, baseFontSize) {
  var _elementsOfUnitedNumb = (0, _parse.elementsOfUnitedNumberString)(value),
      _elementsOfUnitedNumb2 = _slicedToArray(_elementsOfUnitedNumb, 2),
      number = _elementsOfUnitedNumb2[0],
      unit = _elementsOfUnitedNumb2[1];

  return (0, _predicate.isUnitRemOrEm)(unit) ? remOrEmToPxValue(number, baseFontSize) : number;
};

var adjustNumberWithUnit = exports.adjustNumberWithUnit = (0, _ramda.curry)(function (f, value) {
  // In case a unitless number is passed in
  if ((0, _ramdaAdjunct.isNumber)(value)) return f(value);
  // Otherwise calculate using the numeric part and reattach the unit

  var _elementsOfUnitedNumb3 = (0, _parse.elementsOfUnitedNumberString)(value),
      _elementsOfUnitedNumb4 = _slicedToArray(_elementsOfUnitedNumb3, 2),
      n = _elementsOfUnitedNumb4[0],
      unit = _elementsOfUnitedNumb4[1];

  return '' + f(n) + unit;
});


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/converters.js
// module id = 67
// module chunks = 168707334958949